module.exports = __webpack_public_path__ + "static/media/Rubik-Light.6b6fbdd4.woff2";